import React from 'react'
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'

export enum LeadWelcomeAccountsAnalyticsTab {
  IPAddressAnalytics = 'ip-address-analytics',
  DeviceKeyAnalytics = 'device-key-analytics',
  DetailedAnalytics = 'detailed-analytics',
}

export const isIPAddressAnalytics = (
  leadWelcomeAccountsAnalytics: LeadWelcomeAccountsAnalyticsTab
): boolean => {
  return leadWelcomeAccountsAnalytics === LeadWelcomeAccountsAnalyticsTab.IPAddressAnalytics
}

export const isDeviceKeyAnalytics = (
  leadWelcomeAccountsAnalytics: LeadWelcomeAccountsAnalyticsTab
): boolean => {
  return leadWelcomeAccountsAnalytics === LeadWelcomeAccountsAnalyticsTab.DeviceKeyAnalytics
}

export const isDetailedAnalytics = (
  leadWelcomeAccountsAnalytics: LeadWelcomeAccountsAnalyticsTab
): boolean => {
  return leadWelcomeAccountsAnalytics === LeadWelcomeAccountsAnalyticsTab.DetailedAnalytics
}

interface LeadWelcomeAccountsAnalyticsNavigationProps {
  activeKey: LeadWelcomeAccountsAnalyticsTab
  onChange(key: string): void
}

export const LeadWelcomeAccountsAnalyticsNavigation: React.FC<
  LeadWelcomeAccountsAnalyticsNavigationProps
> = (props) => {
  const { activeKey, onChange } = props

  return (
    <Tabs value={activeKey} onValueChange={onChange} className='mt-2'>
      <TabsList>
        <TabsTrigger value={LeadWelcomeAccountsAnalyticsTab.IPAddressAnalytics}>
          IP Address Analytics
        </TabsTrigger>
        <TabsTrigger value={LeadWelcomeAccountsAnalyticsTab.DeviceKeyAnalytics}>
          Device Key Analytics
        </TabsTrigger>
      </TabsList>
    </Tabs>
  )
}
